import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useParams, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { Privilege_API } from "../../APIs/Privilege.api";
import Account from "../../Components/Option/Acount";
import Select from "react-select";
import {
  EditorState,
  convertToRaw,
  ContentState,
  Modifier,
  convertFromHTML,
} from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

import draftToHtml from "draftjs-to-html";
import ChangePassword from "./components/ChangePassword";
import ChangeProfile from "./components/ChangeProfile";
import { Pagination } from "../../Components/Pagination";

export function UserContainer() {
  const { lang, proxy, auth, functions } = useSelector((state) => state);
  const { id_str } = useParams();
  const [showModal, setShowModal] = useState(false);
  const _token = localStorage.getItem("_token");
  const stringifiedUser = localStorage.getItem("user");
  const users = JSON.parse(stringifiedUser);
  const [errorMessagesadd, setErrorMessagesadd] = useState({});
  const [errorMessagesedit, setErrorMessagesedit] = useState({});
  const [isLoading, setLoading] = useState(true);
  const [statusActive, setStatusActive] = useState(false);
  const [refreshPage, setRefreshPage] = useState(0);
  const navigate = useNavigate();
  const message = useRef("");
  const roles = [
    { id: 0, label: "Administrator", value: "ad" },
    // { id: 1, label: "Operator", value: "pm" },
    { id: 2, label: "Normal", value: "pd" },
    // { id: 3, label: "Người theo dõi dự án ( Monitor Staff )", value: "ps" },
  ];

  const status = [
    { id: 0, label: "Active", value: true },
    { id: 1, label: "Inactive", value: false },
  ];

  const [user, setUser] = useState({});
  const [editUser, setEditUser] = useState({});
  const [foreignField, setForeignField] = useState([]);
  const currentForeign = useRef();

  // Close Modal
  const handleCloseModal = () => {
    setErrorMessagesadd({});
    setErrorMessagesedit({});
    setEditUser({
      username: "",
      password: "",
      fullname: "",
      role: "",
      email: "",
      phone: "",
      address: "",
      note: "",
      warhouse: "",
      //   privilege: {
      //     privilegegroup_id: -1, // int
      //     groupname: "",
      //     id: -1, //int
      //   }
    });
    setUser({
      username: "",
      password: "",
      confirmPassword: "",
      fullname: "",
      role: "",
      email: "",
      phone: "",
      address: "",
      note: "",
      warhouse: "",
    });
    setShowModal(false);
  };
  // Get all user
  const [profiles, setProfile] = useState([]);
  useEffect(() => {
    fetch(`${proxy()}/auth/activation/check`, {
      headers: {
        Authorization: _token,
      },
    })
      .then((res) => res.json())
      .then((resp) => {
        const { success, data, activated, status, content } = resp;
        // //console.log(resp)
        if (activated) {
          fetch(`${proxy()}/auth/all/accounts`, {
            headers: {
              Authorization: _token,
            },
          })
            .then((res) => res.json())
            .then((resp) => {
              const { success, data, table } = resp;
              // //console.log(resp)
              if (success) {
                if (data && data.length > 0) {
                  setProfile(data);
                  if (table) {
                    setForeignField(table);
                  }
                }
              } else {
                message.current = resp.message;
                // window.location = "/login";
              }
            });
          setStatusActive(true);
        } else {
          Swal.fire({
            title: lang["faild"],
            text: lang["fail.active"],
            icon: "error",
            showConfirmButton: true,
            customClass: {
              confirmButton: "swal2-confirm my-confirm-button-class",
            },
          }).then(function () {
            // window.location.reload();
          });
          setStatusActive(false);
        }
      })
      .finally(() => setLoading(false));
  }, [refreshPage]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUser((prevUser) => ({
      ...prevUser,
      [name]: value,
    }));
  };
  // Check email, phone
  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  const isValidPhone = (phone) => {
    const phoneRegex = /^[0-9]{10}$/; // Kiểm tra 10 chữ số
    return phoneRegex.test(phone);
  };
  // Add user
  const submit = (e) => {
    e.preventDefault();
    const { username, password, fullname, role, email, phone, address } = user;
    const errors = {};
    if (!username) {
      errors.username = lang["error.username"];
    }

    // if (username.toLowerCase() === "administrator") {
    //     errors.username = lang["username not available"];

    // }

    if (!password) {
      errors.password = lang["error.password"];
    }
    if (!fullname) {
      errors.fullname = lang["error.fullname"];
    }
    if (!role) {
      errors.role = lang["error.permission"];
    }

    if (!email) {
      errors.email = lang["error.email"];
    } else if (!isValidEmail(email)) {
      errors.email = lang["error.vaildemail"];
    }
    if (!phone) {
      errors.phone = lang["error.phone"];
    } else if (!isValidPhone(phone)) {
      errors.phone = lang["error.vaildphone"];
    }
    if (!address) {
      errors.address = lang["error.address"];
    }
    if (user?.password != user?.confirmPassword) {
      errors.confirmPassword = lang["error.confirmpassowrd"];
    }

    if (Object.keys(errors).length > 0) {
      setErrorMessagesadd(errors);
      return;
    }
    // //console.log(_token);
    if (user?.username && user?.password) {
      fetch(`${proxy()}/auth/signup`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${_token}`,
        },
        body: JSON.stringify({ account: user }),
      })
        .then((res) => res.json())
        .then((resp) => {
          const { success, content, data, status } = resp;
          if (!success && content) {
            return Swal.fire({
              title: lang["faild"],
              text: content,
              icon: "error",
              showConfirmButton: true,
              customClass: {
                confirmButton: "swal2-confirm my-confirm-button-class",
              },
            });
          }
          functions.showApiResponseMessage(status);
        });
    }
  };
  // Remove user
  const handleDeleteUser = (user) => {
    const requestBody = {
      account: {
        username: user?.username,
      },
    };
    Swal.fire({
      title: "Xác nhận xóa",
      text: "Bạn có chắc chắn muốn xóa người dùng này?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Xóa",
      cancelButtonText: "Hủy",
      confirmButtonColor: "rgb(209, 72, 81)",
    }).then((result) => {
      if (result.isConfirmed) {
        fetch(`${proxy()}/auth/user`, {
          method: "DELETE",
          headers: {
            "content-type": "application/json",
            Authorization: `${_token}`,
          },
          body: JSON.stringify(requestBody),
        })
          .then((res) => res.json())
          .then((resp) => {
            const { success, content, data, status } = resp;
            functions.showApiResponseMessage(status);
          });
      }
    });
    // //console.log(requestBody)
  };
  // Update user
  const submitUpdate = (e) => {
    e.preventDefault();

    const errors = {};

    if (!editUser.fullname) {
      errors.fullname = lang["error.fullname"];
    }
    if (!editUser.role) {
      errors.role = lang["error.permission"];
    }

    if (!editUser.email) {
      errors.email = lang["error.email"];
    } else if (!isValidEmail(editUser.email)) {
      errors.email = lang["error.vaildemail"];
    }
    if (!editUser.phone) {
      errors.phone = lang["error.phone"];
    } else if (!isValidPhone(editUser.phone)) {
      errors.phone = lang["error.vaildphone"];
    }
    if (!editUser.address) {
      errors.address = lang["error.address"];
    }

    if (Object.keys(errors).length > 0) {
      setErrorMessagesedit(errors);
      return;
    }
    const requestBody = {
      account: {
        ...editUser,
      },
    };

    //console.log(requestBody)
    fetch(`${proxy()}/auth/user`, {
      method: "PUT",
      headers: {
        "content-type": "application/json",
        Authorization: `${_token}`,
      },
      body: JSON.stringify(requestBody),
    })
      .then((res) => res.json())
      .then((resp) => {
        const { success, content, status } = resp;
        const newProfiles = profiles.map((user) => {
          if (user?.username == editUser.username) {
            return editUser;
          } else {
            return user;
          }
        });
        setProfile(newProfiles);
        functions.showApiResponseMessage(status);
      });
  };
  const handleUpdateUser = (editUser) => {
    // //console.log("Thông tin người dùng:", editUser.role);
    setEditUser(editUser);
    // if (editUser.role === users.role) {
    //     Swal.fire({
    //         title: "Thất bại!",
    //         text: "Không có quyền thực hiện thao tác",
    //         icon: "error",
    //         // showConfirmButton: false,

    //     }).then(function () {
    //          window.location.reload();
    //         $('.modal-backdrop').remove()
    //     });
    //     setShowModal(false);
    //     return;
    // } else {
    //     setEditUser(editUser)
    //     setShowModal(true);
    // }
  };

  const admins = profiles.filter((profile) => profile.role === "ad");
  const projectManagers = profiles.filter((profile) => profile.role === "pm");
  const implementers = profiles.filter((profile) => profile.role === "pd");
  const projectFollowers = profiles.filter((profile) => profile.role === "ps");

  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 14;

  const indexOfLastUser = currentPage * rowsPerPage;
  const indexOfFirstUser = indexOfLastUser - rowsPerPage;
  const currentUser = profiles.slice(indexOfFirstUser, indexOfLastUser);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const totalPages = Math.ceil(profiles.length / rowsPerPage);
  const { getAllPrivilegeGroup, updatePrivilegeGroupByUsername } =
    Privilege_API;
  /* PRIVILEGE GROUP */
  const [privilegeGroup, setPrivilegeGroup] = useState();
  /*  */
  useEffect(() => {
    getAllPrivilegeGroup(proxy(), _token)
      .then((data) => {
        setPrivilegeGroup(data);
      })
      .catch((e) => console.log("GET ALL PRIVILEGE GROUP ERROR::", e));
  }, []);
  const customStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    menu: (base) => ({ ...base, zIndex: 9999 }),
  };
  const [isToggle, setIsToggle] = useState({ search: false });
  const [userInfo, setUserInfo] = useState({});
  const [options, setOptions] = useState([]);
  const InputList = [
    { label: "Tài khoản", key: "username" },
    { label: "Nhập vào họ và tên để tìm kiếm", key: "fullname" },
    {
      label: "Quyền",
      type: "option",
      key: "privilegeGroup",
      isClearable: true,
    },
    { label: "Email", key: "email" },
    { label: "Số điện thoại", key: "phone" },
  ];
  useEffect(() => {
    (async () => {
      const response = await fetch(`${proxy()}/privileges/groups`, {
        headers: { authorization: _token },
      });
      const result = await response.json();
      setOptions(
        result?.groups?.map(({ privilegegroup_id, group_name }) => ({
          label: group_name,
          value: privilegegroup_id,
        })) || []
      );
    })();
  }, []);

  const handleSearch = async (userInfo) => {
    try {
      let query = "";
      for (const k in userInfo) {
        query += `&${k}=${userInfo[k]}`;
      }
      const response = await fetch(`${proxy()}/auth/v2/u/?${query.slice(1)}`, {
        headers: { authorization: _token },
      });
      const result = await response.json();
      // if(result.user.length > 0){
      setProfile(result.users);
      setCurrentPage(1);
      // }
    } catch (error) {
      console.error("Error fetching user info:", error);
    }
  };

  return (
    <div class="midde_cont">
      <div class="container-fluid">
        <div class="row column_title">
          <div class="col-md-12">
            <div class="page_title d-flex align-items-center justify-content-between">
              <h4 class="ml-1">{lang["accounts manager"]}</h4>
              <section class="mr-3">
                {/* <button
                  class="btn btn-secondary m-0"
                  type="button"
                  data-toggle="collapse"
                  data-target="#Search"
                  aria-expanded="true"
                  aria-controls="Search"
                  // onClick={() =>
                  //   setIsToggle((prev) => ({ ...prev, search: !prev.search }))
                  // }
                >
                  {lang["search"]}
                </button> */}
                {["uad", "pm"].includes(auth?.role) ||
                auth?.ct?.find(
                  ({ table_alias, write }) =>
                    table_alias === "accounts" && write
                ) ? (
                  <Link
                    to="/users/creating"
                    style={{ marginTop: 0 }}
                    class="btn btn-primary btn-custom custom-button add m-0 ml-2"
                  >
                    <i class="fa fa-plus"></i>
                  </Link>
                ) : null}
              </section>
            </div>
          </div>
        </div>
        {/* {isToggle.search ? ( */}
        {/* <div
          id="Search"
          class="accordion-collapse collapse"
          data-parent="#Search"
        >
          <SearchComponent
            onChange={(users) => {
              setProfile(users);
            }}
          />
        </div> */}
        {/* ) : null} */}
        <div class="row column1">
          <div class="white_shd full margin_bottom_30">
            {/* Modal add */}
            <div
              class="modal no-select-modal fade"
              id="quoteForm"
              tabindex="-1"
              role="dialog"
              aria-labelledby="quoteForm"
              aria-hidden="true"
            >
              <div
                class="modal-dialog modal-lg modal-dialog-center"
                role="document"
              >
                <div class="modal-content p-md-3">
                  <div class="modal-header">
                    <h4 class="modal-title">{lang["adduser.title"]} </h4>
                    <button
                      class="close"
                      type="button"
                      onClick={handleCloseModal}
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">×</span>
                    </button>
                  </div>
                  <div
                    class="modal-body"
                    style={{
                      height: "600px",
                      overflow: "auto",
                    }}
                  >
                    <form>
                      <div class="row">
                        <div class="form-group col-lg-6">
                          <label
                            class="font-weight-bold text-small"
                            for="firstname"
                          >
                            {lang["fullname"]}
                            <span className="red_star ml-1">*</span>
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            value={user?.fullname}
                            onChange={(e) => {
                              setUser({ ...user, fullname: e.target.value });
                            }}
                            placeholder={lang["p.fullname"]}
                          />
                          {errorMessagesadd.fullname && (
                            <span class="error-message">
                              {errorMessagesadd.fullname}
                            </span>
                          )}
                        </div>
                        <div class="form-group col-lg-6">
                          <label
                            class="font-weight-bold text-small"
                            for="firstname"
                          >
                            {lang["username"]}
                            <span className="red_star ml-1">*</span>
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            value={user?.username}
                            onChange={(e) => {
                              setUser({ ...user, username: e.target.value });
                            }}
                            placeholder={lang["p.username"]}
                          />
                          {errorMessagesadd.username && (
                            <span class="error-message">
                              {errorMessagesadd.username}
                            </span>
                          )}
                        </div>
                        <div class="form-group col-lg-6">
                          <label
                            class="font-weight-bold text-small"
                            for="lastname"
                          >
                            {lang["password"]}
                            <span className="red_star ml-1">*</span>
                          </label>
                          <input
                            type="password"
                            class="form-control"
                            value={user?.password}
                            onChange={(e) => {
                              setUser({ ...user, password: e.target.value });
                            }}
                            placeholder={lang["p.password"]}
                          />
                          {errorMessagesadd.password && (
                            <span class="error-message">
                              {errorMessagesadd.password}
                            </span>
                          )}
                        </div>
                        <div class="form-group col-lg-6">
                          <label
                            class="font-weight-bold text-small"
                            for="lastname"
                          >
                            {lang["re-password"]}
                            <span className="red_star ml-1">*</span>
                          </label>
                          <input
                            type="password"
                            class="form-control"
                            value={user?.confirmPassword}
                            onChange={(e) => {
                              setUser({
                                ...user,
                                confirmPassword: e.target.value,
                              });
                            }}
                            placeholder={lang["p.re-password"]}
                          />
                          {errorMessagesadd.confirmPassword && (
                            <span class="error-message">
                              {errorMessagesadd.confirmPassword}
                            </span>
                          )}
                        </div>
                        <div class="form-group col-lg-12">
                          <label
                            class="font-weight-bold text-small"
                            for="email"
                          >
                            {lang["email"]}
                            <span class="red_star ml-1">*</span>
                          </label>
                          <input
                            type="email"
                            class="form-control"
                            value={user?.email}
                            onChange={(e) => {
                              setUser({ ...user, email: e.target.value });
                            }}
                            placeholder={lang["p.email"]}
                          />
                          {errorMessagesadd.email && (
                            <span class="error-message">
                              {errorMessagesadd.email}
                            </span>
                          )}
                        </div>
                        <div class="form-group col-lg-6">
                          <label
                            class="font-weight-bold text-small"
                            for="phone"
                          >
                            {lang["phone"]}
                            <span class="red_star ml-1">*</span>
                          </label>
                          <input
                            type="phone"
                            class="form-control"
                            value={user?.phone}
                            onChange={(e) => {
                              setUser({ ...user, phone: e.target.value });
                            }}
                            placeholder={lang["p.phone"]}
                          />
                          {errorMessagesadd.phone && (
                            <span class="error-message">
                              {errorMessagesadd.phone}
                            </span>
                          )}
                        </div>
                        <div class="form-group col-lg-6">
                          <label
                            class="font-weight-bold text-small"
                            for="projecttype"
                          >
                            {lang["permission"]}
                            <span class="red_star ml-1">*</span>
                          </label>
                          <select
                            className="form-control"
                            name="role"
                            value={user?.role}
                            onChange={handleChange}
                          >
                            <option value="">{lang["p.permission"]}</option>
                            {auth?.role === "ad"
                              ? roles.slice(0, 4).map((role) => (
                                  <option key={role.id} value={role.value}>
                                    {role.label}
                                  </option>
                                ))
                              : roles.map((role) => (
                                  <option key={role.id} value={role.value}>
                                    {role.label}
                                  </option>
                                ))}
                          </select>
                          {errorMessagesadd.role && (
                            <span className="error-message">
                              {errorMessagesadd.role}
                            </span>
                          )}
                        </div>
                        <div class="form-group col-lg-12">
                          <label
                            class="font-weight-bold text-small"
                            for="projectdetail"
                          >
                            {lang["warhouse"]}
                          </label>
                          <Account
                            lang={lang}
                            proxy={proxy}
                            foreignField={foreignField}
                            primary_key={foreignField?.primary_key}
                            setUser={setUser}
                            user={user}
                            currentForeign={currentForeign}
                          />
                        </div>
                        <div class="form-group col-lg-12">
                          <label
                            class="font-weight-bold text-small"
                            for="projectdetail"
                          >
                            {lang["address"]}
                            <span class="red_star ml-1">*</span>
                          </label>
                          <textarea
                            maxlength="500"
                            rows="5"
                            type="text"
                            class="form-control"
                            value={user?.address}
                            onChange={(e) => {
                              setUser({ ...user, address: e.target.value });
                            }}
                            placeholder={lang["p.address"]}
                          />
                          {errorMessagesadd.address && (
                            <span class="error-message">
                              {errorMessagesadd.address}
                            </span>
                          )}
                        </div>
                        <div class="form-group col-lg-12">
                          <label
                            class="font-weight-bold text-small"
                            for="projectdetail"
                          >
                            {lang["note"]}
                          </label>
                          <textarea
                            maxlength="500"
                            rows="5"
                            type="text"
                            class="form-control"
                            value={user?.note}
                            onChange={(e) => {
                              setUser({ ...user, note: e.target.value });
                            }}
                            placeholder={lang["p.note"]}
                          />
                        </div>
                      </div>
                    </form>
                  </div>
                  <div class="modal-footer">
                    <button
                      type="button"
                      style={{ minWidth: "105px" }}
                      onClick={submit}
                      class="btn btn-success btn-custom"
                    >
                      {lang["btn.create"]}
                    </button>
                    <button
                      type="button"
                      style={{ minWidth: "105px" }}
                      onClick={handleCloseModal}
                      data-dismiss="modal"
                      class="btn btn-danger"
                    >
                      {lang["btn.close"]}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {/* Modal edit */}
            <div
              class="modal no-select-modal fade"
              tabindex="-1"
              role="dialog"
              id="myEditmodal"
              aria-labelledby="edit"
              aria-hidden="true"
            >
              <div
                class="modal-dialog modal-lg modal-dialog-center"
                role="document"
              >
                <div class="modal-content p-md-3">
                  <div class="modal-header">
                    <h4 class="modal-title">{lang["edituser.title"]} </h4>

                    <button
                      class="close"
                      type="button"
                      onClick={handleCloseModal}
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">×</span>
                    </button>
                  </div>
                  <div
                    class="modal-body"
                    style={{
                      height: "600px",
                      overflow: "auto",
                    }}
                  >
                    <form>
                      <div class="row">
                        <div class="form-group col-lg-12">
                          <label
                            class="font-weight-bold text-small"
                            for="firstname"
                          >
                            {lang["fullname"]}
                            <span className="red_star ml-1">*</span>
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            value={editUser.fullname}
                            onChange={(e) => {
                              setEditUser({
                                ...editUser,
                                fullname: e.target.value,
                              });
                            }}
                            placeholder={lang["p.fullname"]}
                          />
                          {errorMessagesedit.fullname && (
                            <span class="error-message">
                              {errorMessagesedit.fullname}
                            </span>
                          )}
                        </div>
                        <div class="form-group col-lg-6">
                          <label
                            class="font-weight-bold text-small"
                            for="email"
                          >
                            {lang["email"]}
                            <span class="red_star ml-1">*</span>
                          </label>
                          <input
                            type="email"
                            class="form-control"
                            value={editUser.email}
                            onChange={(e) => {
                              setEditUser({
                                ...editUser,
                                email: e.target.value,
                              });
                            }}
                            placeholder={lang["p.email"]}
                          />
                          {errorMessagesedit.email && (
                            <span class="error-message">
                              {errorMessagesedit.email}
                            </span>
                          )}
                        </div>
                        <div class="form-group col-lg-6">
                          <label
                            class="font-weight-bold text-small"
                            for="phone"
                          >
                            {lang["phone"]}
                            <span class="red_star ml-1">*</span>
                          </label>
                          <input
                            type="phone"
                            class="form-control"
                            value={editUser.phone}
                            onChange={(e) => {
                              setEditUser({
                                ...editUser,
                                phone: e.target.value,
                              });
                            }}
                            placeholder={lang["p.phone"]}
                          />
                          {errorMessagesedit.phone && (
                            <span class="error-message">
                              {errorMessagesedit.phone}
                            </span>
                          )}
                        </div>
                        <div class="form-group col-lg-6">
                          <label
                            class="font-weight-bold text-small"
                            for="password"
                          >
                            {lang["p.re-password"]}
                            <span class="red_star ml-1">*</span>
                          </label>
                          <input
                            type="password"
                            class="form-control"
                            // value={editUser.password}
                            onChange={(e) => {
                              setEditUser({
                                ...editUser,
                                oldPassword: e.target.value,
                              });
                            }}
                            placeholder={lang["p.re-password"]}
                          />
                          {errorMessagesedit.email && (
                            <span class="error-message">
                              {errorMessagesedit.password}
                            </span>
                          )}
                        </div>
                        <div class="form-group col-lg-6">
                          <label
                            class="font-weight-bold text-small"
                            for="newpassword"
                          >
                            {lang["p.new password"]}
                            <span class="red_star ml-1">*</span>
                          </label>
                          <input
                            type="password"
                            class="form-control"
                            // value={editUser.password}
                            onChange={(e) => {
                              setEditUser({
                                ...editUser,
                                newPassword: e.target.value,
                              });
                            }}
                            placeholder={lang["p.new password"]}
                          />
                          {errorMessagesedit.email && (
                            <span class="error-message">
                              {errorMessagesedit.password}
                            </span>
                          )}
                        </div>
                        <div class="form-group col-lg-6">
                          <label
                            class="font-weight-bold text-small"
                            htmlFor="sel1"
                          >
                            {lang["permission"]}{" "}
                            <span className="red_star">*</span>
                          </label>
                          <select
                            className="form-control"
                            name="role"
                            value={editUser.role}
                            onChange={(e) =>
                              setEditUser({
                                ...editUser,
                                role: e.target.value,
                              })
                            }
                          >
                            {["ad", "pm"].includes(auth?.role)
                              ? roles.slice(0, 4).map((role) => (
                                  <option key={role.id} value={role.value}>
                                    {role.label}
                                  </option>
                                ))
                              : roles.map((role) => (
                                  <option key={role.id} value={role.value}>
                                    {role.label}
                                  </option>
                                ))}
                          </select>
                          {errorMessagesedit.role && (
                            <span class="error-message">
                              {errorMessagesedit.role}
                            </span>
                          )}
                        </div>

                        <div class="form-group col-lg-6">
                          <label
                            class="font-weight-bold text-small"
                            htmlFor="sel1"
                          >
                            {lang["account status"]}{" "}
                            <span className="red_star">*</span>
                          </label>
                          <select
                            className="form-control"
                            name="role"
                            value={editUser.status}
                            onChange={(e) =>
                              setEditUser({
                                ...editUser,
                                status: e.target.value === "true",
                              })
                            }
                          >
                            {status.map((sta) => (
                              <option key={sta.id} value={sta.value}>
                                {lang[`${sta.label}`]}
                              </option>
                            ))}
                          </select>
                          {errorMessagesedit.role && (
                            <span class="error-message">
                              {errorMessagesedit.role}
                            </span>
                          )}
                        </div>
                        <div class="form-group col-lg-12">
                          <label
                            class="font-weight-bold text-small"
                            for="projectdetail"
                          >
                            {lang["warhouse"]}
                          </label>
                          <Account
                            lang={lang}
                            proxy={proxy}
                            foreignField={foreignField}
                            primary_key={foreignField.primary_key}
                            setUser={setUser}
                            user={user}
                            editUser={editUser}
                            setEditUser={setEditUser}
                            currentForeign={currentForeign}
                          />
                        </div>
                        <div class="form-group col-lg-12">
                          <label
                            class="font-weight-bold text-small"
                            for="projectdetail"
                          >
                            {lang["address"]}
                            <span class="red_star ml-1">*</span>
                          </label>
                          <textarea
                            maxlength="500"
                            rows="5"
                            type="text"
                            class="form-control"
                            value={editUser.address}
                            onChange={(e) => {
                              setEditUser({
                                ...editUser,
                                address: e.target.value,
                              });
                            }}
                            placeholder={lang["p.address"]}
                          />
                          {errorMessagesedit.address && (
                            <span class="error-message">
                              {errorMessagesedit.address}
                            </span>
                          )}
                        </div>
                        <div class="form-group col-lg-12">
                          <label
                            class="font-weight-bold text-small"
                            for="projectdetail"
                          >
                            {lang["note"]}
                          </label>
                          <textarea
                            maxlength="500"
                            rows="5"
                            type="text"
                            class="form-control"
                            value={editUser.note}
                            onChange={(e) => {
                              setEditUser({
                                ...editUser,
                                note: e.target.value,
                              });
                            }}
                            placeholder={lang["p.note"]}
                          />
                        </div>
                      </div>
                    </form>
                  </div>
                  <div class="modal-footer">
                    <button
                      type="button"
                      onClick={submitUpdate}
                      class="btn btn-success"
                    >
                      {lang["btn.update"]}
                    </button>
                    <button
                      type="button"
                      onClick={handleCloseModal}
                      data-dismiss="modal"
                      class="btn btn-danger"
                    >
                      {lang["btn.close"]}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {/* List user */}
            <div
              class="full graph_head"
              style={{
                borderBottom: " 1px solid rgb(221, 221, 221)",
              }}
            >
              <div class="heading1 margin_0">
                <h5>
                  <label
                    // class="pointer"
                    style={{ margin: 0 }}
                    // onClick={() => navigate(-1)}
                  >
                    {/* <a title={lang["back"]}>
                      <i class=" fa fa-chevron-circle-left mr-1 nav-item nav-link"></i>
                    </a> */}
                    {lang["accounts list"]}
                  </label>
                </h5>
              </div>
            </div>
            <div
              class="full price_table fix-height d-flex flex-column justify-content-between"
              style={{ height: "78.4vh", padding: "6px 12px 0px" }}
            >
              <div class="table-responsive">
                <>
                  <table class="table table">
                    <thead>
                      <tr class="color-tr">
                        <th
                          class="font-weight-bold align-center"
                          style={{ width: "30px" }}
                          scope="col"
                        >
                          #
                        </th>
                        <th class="font-weight-bold align-center" scope="col">
                          {lang["username"]}
                        </th>
                        <th
                          class="font-weight-bold  align-center"
                          style={{ width: "300px" }}
                          scope="col"
                        >
                          {lang["fullname"]}
                        </th>

                        <th
                          class="font-weight-bold  align-center"
                          style={{ width: "120px" }}
                          scope="col"
                        >
                          {lang["privileges groups"]}
                        </th>
                        <th
                          class="font-weight-bold  align-center"
                          style={{ width: "300px" }}
                          scope="col"
                        >
                          {lang["email"]}
                        </th>
                        <th
                          class="font-weight-bold  align-center"
                          style={{ width: "140px" }}
                          scope="col"
                        >
                          {lang["phone"]}
                        </th>
                        <th
                          class="font-weight-bold align-center"
                          style={{ width: "120px" }}
                          scope="col"
                        >
                          {lang["avatar"]}
                        </th>
                        <th
                          class="font-weight-bold  align-center"
                          style={{ width: "130px" }}
                          scope="col"
                        >
                          {lang["account status"]}
                        </th>
                        {["pm", "uad"].includes(auth.role) ||
                        auth?.ct?.find(
                          ({ table_alias, update, delete: _d }) =>
                            table_alias === "accounts" && (update || _d)
                        ) ? (
                          <th
                            class="font-weight-bold align-center"
                            style={{ width: "80px" }}
                          >
                            {lang["log.action"]}
                          </th>
                        ) : null}
                      </tr>
                      <tr>
                        <td></td>
                        {InputList.map(({ key, type, isClearable }, index) => (
                          <td>
                            {type === "option" ? (
                              <Select
                                options={options}
                                isMulti
                                isClearable={isClearable}
                                isSearchable
                                // value={defaultValue}
                                onChange={(options) => {
                                  let value = [];
                                  if (!options) {
                                    setUserInfo((prev) => ({
                                      ...prev,
                                      [key]: null,
                                    }));
                                    handleSearch({
                                      ...userInfo,
                                      [key]: null,
                                    });
                                  } else {
                                    if (Array.isArray(options)) {
                                      value = options.map(
                                        (option) => option.value
                                      );
                                    } else {
                                      value.push(options.value);
                                    }
                                    setUserInfo((prev) => ({
                                      ...prev,
                                      [key]: value,
                                    }));
                                    handleSearch({
                                      ...userInfo,
                                      [key]: value,
                                    });
                                  }
                                }}
                                menuPosition="fixed"
                                styles={{
                                  menuPortal: (provided) => ({
                                    ...provided,
                                    zIndex: 9999,
                                  }),
                                  menu: (provided) => ({
                                    ...provided,
                                    zIndex: 9999,
                                  }),
                                }}
                                placeholder={<>{lang["p.permission"]}</>}
                                noOptionsMessage={() => (
                                  <>{lang["not found data"]}</>
                                )}
                              />
                            ) : (
                              <input
                                className="form-control"
                                type="text"
                                onChange={(e) => {
                                  const { value } = e.target;
                                  const roleMap = {
                                    ad: "Quản trị viên",
                                    pd: "Người dùng",
                                  };
                                  if (key === "role") {
                                    const dbRole = Object.keys(roleMap).find(
                                      (key) => roleMap[key] === value.trim()
                                    );
                                    setUserInfo((prev) => ({
                                      ...prev,
                                      [key]: dbRole,
                                    }));
                                    handleSearch({
                                      ...userInfo,
                                      [key]: dbRole,
                                    });
                                  } else {
                                    setUserInfo((prev) => ({
                                      ...prev,
                                      [key]: value.trim(),
                                    }));
                                    handleSearch({
                                      ...userInfo,
                                      [key]: value.trim(),
                                    });
                                  }
                                }}
                              />
                            )}
                          </td>
                        ))}
                        <td></td>
                        <td></td>
                        {auth?.ct?.find(
                          ({ table_alias, update }) =>
                            table_alias === "accounts" && update
                        ) || ["uad", "pm"].includes(auth?.role) ? (
                          <td></td>
                        ) : null}
                      </tr>
                    </thead>
                    <tbody>
                      {isLoading ? (
                        <tr>
                          <td colSpan={10} className="align-center">
                            <img
                              width={35}
                              className="mb-1"
                              src="/images/icon/load.gif"
                              alt="Loading..."
                            />
                          </td>
                        </tr>
                      ) : currentUser && currentUser.length > 0 ? (
                        currentUser
                          .filter((item) => item.role !== "uad")
                          .map((profile, index) => {
                            const newImg = proxy() + profile.avatar ? "a" : "b";
                            console.log("newImgnewImg", profile.avatar);
                            let mappedGroup = {};
                            const findIdGroup = privilegeGroup?.groups?.find(
                              (item) =>
                                profile?.privilege?.privilegegroup_id ===
                                item.privilegegroup_id
                            );
                            if (findIdGroup) {
                              mappedGroup = {
                                ...findIdGroup,
                                label: findIdGroup.group_name,
                                value: findIdGroup.group_name,
                              };
                            }
                            return (
                              <tr key={index}>
                                <td>{indexOfFirstUser + index + 1}</td>
                                <td
                                  style={{
                                    minWidth: "200px",
                                    maxWidth: "250px",
                                  }}
                                  class="cell_user"
                                  title={profile.username}
                                >
                                  {profile.username}
                                </td>
                                <td
                                  style={{
                                    minWidth: "250px",
                                    maxWidth: "300px",
                                  }}
                                  class="cell_user"
                                  title={profile.fullname}
                                >
                                  {profile.fullname}
                                </td>

                                <td
                                  style={{
                                    minWidth: "200px",
                                  }}
                                >
                                  {/* <Select
                                        styles={customStyles}
                                        menuPosition={"fixed"}
                                        options={[
                                          {
                                            label: lang["default value"],
                                            value: "default_value",
                                          },
                                          ...(privilegeGroup?.groups?.map(
                                            (item) => ({
                                              ...item,
                                              label: item.group_name,
                                              value: item.group_name,
                                            })
                                          ) || []),
                                        ]}
                                        value={mappedGroup}
                                        placeholder={lang["select value"]}
                                        onChange={(option) => {
                                          const checkValue =
                                            option.value === "default_value"
                                              ? option.value
                                              : option.privilegegroup_id;
                                          updatePrivilegeGroupByUsername(
                                            {
                                              privilegegroup_id: checkValue,
                                              username: profile.username,
                                            },
                                            proxy(),
                                            _token
                                          ).then(() => {
                                            Swal.fire({
                                              title: lang["success"],
                                              text: lang["success.update"],
                                              icon: "success",
                                              showConfirmButton: false,
                                              timer: 1500,
                                            }).then(() => {
                                              setRefreshPage(
                                                (prev) => prev + 1
                                              );
                                            });
                                          });
                                        }}
                                      /> */}
                                  {mappedGroup.value}
                                </td>
                                <td
                                  style={{
                                    minWidth: "120px",
                                    maxWidth: "120px",
                                  }}
                                  class="cell_user"
                                  title={profile.email}
                                >
                                  {profile.email}
                                </td>
                                <td title={profile.phone}>{profile.phone}</td>
                                <td
                                  style={{
                                    minWidth: "150px",
                                    maxWidth: "150px",
                                  }}
                                  class="align-center"
                                >
                                  {
                                    <div class="profile_contacts_list_user ">
                                      <img
                                        class="img-responsive circle-image_list_user"
                                        src={proxy() + profile.avatar}
                                        onError={(e) => {
                                          if (
                                            e.target.src !==
                                            proxy() +
                                              "/image/avatar/default-ava.png"
                                          ) {
                                            e.target.src =
                                              proxy() +
                                              "/image/avatar/default-ava.png";
                                          }
                                        }}
                                        alt="#"
                                      />
                                    </div>
                                  }
                                </td>

                                <td
                                  style={{
                                    minWidth: "170px",
                                    maxWidth: "170px",
                                  }}
                                  title={
                                    lang[
                                      `${
                                        status.find(
                                          (s) => s.value === profile.status
                                        ).label
                                      }`
                                    ]
                                  }
                                >
                                  <span
                                    class={` ${
                                      profile.status
                                        ? "online_animation"
                                        : "offline_animation"
                                    } mr-1`}
                                  ></span>
                                  {
                                    lang[
                                      `${
                                        status.find(
                                          (s) => s.value === profile.status
                                        ).label
                                      }`
                                    ]
                                  }
                                </td>

                                {["uad", "pm"].includes(auth?.role) ||
                                auth?.ct?.find(
                                  ({ table_alias, update, delete: _d }) =>
                                    table_alias === "accounts" && (update || _d)
                                ) ? (
                                  <td>
                                    <div class="icon-table">
                                      {auth?.ct?.find(
                                        ({ table_alias, update }) =>
                                          table_alias === "accounts" && update
                                      ) ||
                                      ["uad", "pm"].includes(auth?.role) ? (
                                        <div className="icon-table-line">
                                          <Link
                                            to={`/users/updating/${profile.username}`}
                                          >
                                            <i class="fa fa-edit icon-edit pointer size-24"></i>
                                          </Link>
                                        </div>
                                      ) : null}

                                      {auth?.ct?.find(
                                        ({ table_alias, delete: _d }) =>
                                          table_alias === "accounts" && _d
                                      ) ||
                                      ["uad", "pm"].includes(auth?.role) ? (
                                        <div className="icon-table-line">
                                          <i
                                            class="fa fa-trash-o icon-delete pointer size-24"
                                            onClick={() =>
                                              handleDeleteUser(profile)
                                            }
                                          ></i>
                                        </div>
                                      ) : null}
                                    </div>
                                  </td>
                                ) : null}
                                {/* {[("uad", "pm")].includes(auth?.role) ? (
                                  <td>
                                    <div class="icon-table">
                                      <div className="icon-table-line">
                                        <Link to="/users/updating">
                                          <i class="fa fa-edit icon-edit pointer size-24"></i>
                                        </Link>
                                      </div>
                                      <div className="icon-table-line">
                                        <i
                                          class="fa fa-trash-o icon-delete pointer size-24"
                                          onClick={() =>
                                            handleDeleteUser(profile)
                                          }
                                        ></i>
                                      </div>
                                    </div>
                                  </td>
                                ) : null} */}
                              </tr>
                            );
                          })
                      ) : (
                        <tr>
                          <td colSpan={20} className="align-center">
                            {isLoading
                              ? null
                              : // <img
                              //   width={45}
                              //   className="mb-1"
                              //   src="/images/icon/load.gif"
                              //   alt="Loading..."
                              // ></img>
                              message.current
                              ? lang[message.current]
                              : lang["not found data"]}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </>
              </div>
              {!isLoading && currentUser.length > 0 && (
                <Pagination
                  total={profiles.length}
                  itemsPerPage={rowsPerPage}
                  currentPage={currentPage}
                  paginate={paginate}
                  lang={lang}
                />
                // <div className="d-flex justify-content-between align-items-center mb-2 mt-2">
                //   <p>
                //     {lang["show"]} {indexOfFirstUser + 1}-
                //     {Math.min(indexOfLastUser, profiles.length)} {lang["of"]}{" "}
                //     {profiles.length} {lang["results"]}
                //   </p>
                //   <nav aria-label="Page navigation example">
                //     <ul className="pagination mb-0">
                //       {/* Nút đến trang đầu */}
                //       <li
                //         className={`page-item ${
                //           currentPage === 1 ? "disabled" : ""
                //         }`}
                //       >
                //         <button
                //           className="page-link"
                //           onClick={() => paginate(1)}
                //         >
                //           &#8810;
                //         </button>
                //       </li>
                //       <li
                //         className={`page-item ${
                //           currentPage === 1 ? "disabled" : ""
                //         }`}
                //       >
                //         <button
                //           className="page-link"
                //           onClick={() => paginate(Math.max(1, currentPage - 1))}
                //         >
                //           &laquo;
                //         </button>
                //       </li>
                //       {currentPage > 2 && (
                //         <li className="page-item">
                //           <span className="page-link">...</span>
                //         </li>
                //       )}
                //       {Array(totalPages)
                //         .fill()
                //         .map((_, index) => {
                //           if (
                //             index + 1 === currentPage ||
                //             (index + 1 >= currentPage - 1 &&
                //               index + 1 <= currentPage + 1)
                //           ) {
                //             return (
                //               <li
                //                 key={index}
                //                 className={`page-item ${
                //                   currentPage === index + 1 ? "active" : ""
                //                 }`}
                //               >
                //                 <button
                //                   className="page-link"
                //                   onClick={() => paginate(index + 1)}
                //                 >
                //                   {index + 1}
                //                 </button>
                //               </li>
                //             );
                //           }
                //           return null; // Đảm bảo trả về null nếu không có gì được hiển thị
                //         })}
                //       {currentPage < totalPages - 1 && (
                //         <li className="page-item">
                //           <span className="page-link">...</span>
                //         </li>
                //       )}
                //       <li
                //         className={`page-item ${
                //           currentPage === totalPages ? "disabled" : ""
                //         }`}
                //       >
                //         <button
                //           className="page-link"
                //           onClick={() =>
                //             paginate(Math.min(totalPages, currentPage + 1))
                //           }
                //         >
                //           &raquo;
                //         </button>
                //       </li>
                //       {/* Nút đến trang cuối */}
                //       <li
                //         className={`page-item ${
                //           currentPage === totalPages ? "disabled" : ""
                //         }`}
                //       >
                //         <button
                //           className="page-link"
                //           onClick={() => paginate(totalPages)}
                //         >
                //           &#8811;
                //         </button>
                //       </li>
                //     </ul>
                //   </nav>
                // </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export function Profile() {
  {
    const { lang, proxy, functions } = useSelector((state) => state);
    const navigate = useNavigate();

    const _token = localStorage.getItem("_token");
    const stringifiedUser = localStorage.getItem("user");
    const user = JSON.parse(stringifiedUser);
    const [profile, setProfile] = useState({});
    const [editUser, setEditUser] = useState({});
    const [errorMessagesedit, setErrorMessagesedit] = useState({});
    const [statusActive, setStatusActive] = useState(false);
    const [isChangePassword, setChangePassword] = useState(false);
    const [isAvatar, setAvatar] = useState();

    const roles = [
      { id: 0, label: "Quản trị viên ( Administrator )", value: "ad" },
      { id: 1, label: "Quản lý dự án ( Project manager )", value: "pm" },
      {
        id: 2,
        label: "Người triển khai ( Implementation Staff )",
        value: "pd",
      },
      { id: 3, label: "Người theo dõi dự án ( Monitor Staff )", value: "ps" },
    ];
    const isValidEmail = (email) => {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    };
    const isValidPhone = (phone) => {
      const phoneRegex = /^[0-9]{10}$/;
      return phoneRegex.test(phone);
    };

    console.log(editUser);

    const [editorState, setEditorState] = useState(EditorState.createEmpty());

    const onEditorStateChange = (newEditorState) => {
      setEditorState(newEditorState);
    };

    const handleBeforeInput = (chars, editorState) => {
      if (chars === " ") {
        const currentContent = editorState.getCurrentContent();
        const selection = editorState.getSelection();
        const contentWithSpace = Modifier.insertText(
          currentContent,
          selection,
          "\u00A0"
        );
        const newEditorState = EditorState.push(
          editorState,
          contentWithSpace,
          "insert-characters"
        );
        onEditorStateChange(newEditorState);
        return "handled";
      }
      return "not-handled";
    };

    const handleKeyCommand = (command, editorState) => {
      if (command === "backspace") {
        const currentContent = editorState.getCurrentContent();
        const selection = editorState.getSelection();
        if (selection.isCollapsed() && selection.getStartOffset() === 1) {
          // Không cho xóa khoảng trắng đầu tiên
          return "handled";
        }
      }
      return "not-handled";
    };

    const hanldDataUpdate = () => {
      const contentState = convertFromHTMLToContentState(editUser.note);
      const newEditorState = EditorState.createWithContent(contentState);
      setEditorState(newEditorState);
    };

    const convertFromHTMLToContentState = (htmlString) => {
      const blocksFromHTML = convertFromHTML(htmlString);
      const contentState = ContentState.createFromBlockArray(
        blocksFromHTML.contentBlocks,
        blocksFromHTML.entityMap
      );
      return contentState;
    };

    const uploadImageCallBack = (file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          const data = e.target.result;
          resolve({ data: { link: data } });
        };
        reader.onerror = (e) => {
          reject(e);
        };
        reader.readAsDataURL(file);
      });
    };

    // useEffect(() => {

    //     fetch(`${proxy()}/auth/activation/check`, {
    //         headers: {
    //             Authorization: _token
    //         }
    //     })
    //         .then(res => res.json())
    //         .then(resp => {
    //             const { success, data, activated, status, content } = resp;
    //             // console.log(resp)
    //             if (activated) {

    //                 setStatusActive(true)
    //             }
    //             else {
    //                 Swal.fire({
    //                     title: lang["faild"],
    //                     text: lang["fail.active"],
    //                     icon: "error",
    //                     showConfirmButton: true,

    //                 }).then(function () {
    //                     // window.location.reload();
    //                 });
    //                 setStatusActive(false)
    //             }

    //         })

    // }, [])
    useEffect(() => {
      fetch(`${proxy()}/auth/u/${user}`, {
        headers: {
          Authorization: _token,
        },
      })
        .then((res) => res.json())
        .then((resp) => {
          const { data } = resp;
          // console.log(resp)
          if (data) {
            setProfile(data);
            setEditUser(data);
          }
        });
    }, []);

    const fileInputRef = useRef(null);
    const handleClick = () => {
      fileInputRef.current.click();
    };
    const handleFileUpload = async (e) => {
      const file = e.target.files[0];
      // Xử lý tệp tin tại đây
      if (file) {
        if (file != undefined) {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = (e) => {
            setAvatar(e.target.result);
            fetch(`${proxy()}/auth/self/avatar`, {
              method: "PUT",
              headers: {
                "content-type": "application/json",
                Authorization: _token,
              },
              body: JSON.stringify({ image: e.target.result }),
            })
              .then((res) => res.json())
              .then((data) => {
                const { success, content } = data;
              });
          };
        }
      }
    };
    const submitUpdate = (e) => {
      e.preventDefault();
      const errors = {};

      if (!editUser.fullname) {
        errors.fullname = lang["error.fullname"];
      }
      if (!editUser.role) {
        errors.role = lang["error.permission"];
      }

      if (!editUser.email) {
        errors.email = lang["error.email"];
      } else if (!isValidEmail(editUser.email)) {
        errors.email = lang["error.vaildemail"];
      }
      if (!editUser.phone) {
        errors.phone = lang["error.phone"];
      } else if (!isValidPhone(editUser.phone)) {
        errors.phone = lang["error.vaildphone"];
      }
      if (!editUser.address) {
        errors.address = lang["error.address"];
      }

      if (Object.keys(errors).length > 0) {
        setErrorMessagesedit(errors);
        return;
      }
      editUser.note = draftToHtml(
        convertToRaw(editorState.getCurrentContent())
      );
      const requestBody = {
        account: {
          ...editUser,
        },
      };
      // console.log(requestBody)
      fetch(`${proxy()}/auth/self/info`, {
        method: "PUT",
        headers: {
          "content-type": "application/json",
          Authorization: `${_token}`,
        },
        body: JSON.stringify(requestBody),
      })
        .then((res) => res.json())
        .then((resp) => {
          const { success, content, status } = resp;
          // console.log(resp)
          if (success) {
            const stringifiedUser = JSON.stringify(requestBody.account);
            localStorage.setItem("user", stringifiedUser);
            functions.showApiResponseMessage(status);
          } else {
            functions.showApiResponseMessage(status);
          }
        });
    };
    console.log(draftToHtml(convertToRaw(editorState.getCurrentContent())));
    // if (isChangePassword) {
    //   return <ChangePassword />;
    // }
    return (
      <div className="midde_cont">
        <div className="container-fluid">
          <div className="row column_title">
            <div className="col-md-12">
              <div className="page_title">
                <h4>{lang["profile"]}</h4>
              </div>
            </div>
          </div>
          {!statusActive ? (
            <div className="row column1">
              <div className="col-md-12">
                <div className="white_shd full margin_bottom_30">
                  <div className="ul_infor full graph_head header_infor_user mt-2">
                    <ul className="">
                      <li className="li_info pointer">
                        <a
                          className={`font-weight-bold ${
                            !isChangePassword ? "active" : ""
                          }`}
                          onClick={() => setChangePassword(false)}
                          style={{ color: !isChangePassword && "#0066cc" }}
                        >
                          Thông Tin Tài Khoản
                        </a>
                      </li>
                      <li className={`li_changePass pointer`}>
                        <a
                          className={`font-weight-bold ${
                            isChangePassword ? "active" : ""
                          }`}
                          onClick={() => setChangePassword(true)}
                          style={{ color: isChangePassword && "#0066cc" }}
                        >
                          Đổi Mật Khẩu
                        </a>
                      </li>
                    </ul>
                    {/* <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <div className="heading1 margin_0">
                            <h5>{lang["profile user"]}</h5>
                          </div>
                          {user.role !== "uad" ? (
                            <i
                              className="fa fa-edit size-24 icon-edit pointer"
                              onClick={() => hanldDataUpdate()}
                              data-toggle="modal"
                              data-target="#editMember"
                            ></i>
                          ) : null}
                        </div> */}
                    <div
                      className="modal fade"
                      tabindex="-1"
                      role="dialog"
                      id="editMember"
                      aria-labelledby="edit"
                      aria-hidden="true"
                    >
                      <div
                        className="modal-dialog modal-lg modal-dialog-center"
                        role="document"
                      >
                        <div className="modal-content p-md-3">
                          <div className="modal-header">
                            <h4 className="modal-title">
                              {lang["profile.title"]}{" "}
                            </h4>

                            {/* <button className="close" type="button" onClick={handleCloseModal} data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button> */}
                          </div>
                          <div className="modal-body">
                            <form>
                              <div className="row">
                                <div className="form-group col-lg-6">
                                  <label
                                    className="font-weight-bold text-small"
                                    for="firstname"
                                  >
                                    {lang["fullname"]}
                                    <span className="red_star ml-1">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={editUser.fullname}
                                    onChange={(e) => {
                                      setEditUser({
                                        ...editUser,
                                        fullname: e.target.value,
                                      });
                                    }}
                                    placeholder={lang["p.fullname"]}
                                  />
                                  {errorMessagesedit.fullname && (
                                    <span className="error-message">
                                      {errorMessagesedit.fullname}
                                    </span>
                                  )}
                                </div>

                                <div className="form-group col-lg-12">
                                  <label
                                    className="font-weight-bold text-small"
                                    for="email"
                                  >
                                    {lang["email"]}
                                    <span className="red_star ml-1">*</span>
                                  </label>
                                  <input
                                    type="email"
                                    className="form-control"
                                    value={editUser.email}
                                    onChange={(e) => {
                                      setEditUser({
                                        ...editUser,
                                        email: e.target.value,
                                      });
                                    }}
                                    placeholder={lang["p.email"]}
                                  />
                                  {errorMessagesedit.email && (
                                    <span className="error-message">
                                      {errorMessagesedit.email}
                                    </span>
                                  )}
                                </div>
                                <div className="form-group col-lg-6">
                                  <label
                                    className="font-weight-bold text-small"
                                    for="phone"
                                  >
                                    {lang["phone"]}
                                    <span className="red_star ml-1">*</span>
                                  </label>
                                  <input
                                    type="phone"
                                    className="form-control"
                                    value={editUser.phone}
                                    onChange={(e) => {
                                      setEditUser({
                                        ...editUser,
                                        phone: e.target.value,
                                      });
                                    }}
                                    placeholder={lang["p.phone"]}
                                  />
                                  {errorMessagesedit.phone && (
                                    <span className="error-message">
                                      {errorMessagesedit.phone}
                                    </span>
                                  )}
                                </div>

                                <div className="form-group col-lg-12">
                                  <label
                                    className="font-weight-bold text-small"
                                    for="projectdetail"
                                  >
                                    {lang["address"]}
                                    <span className="red_star ml-1">*</span>
                                  </label>
                                  <textarea
                                    maxlength="500"
                                    rows="5"
                                    type="text"
                                    className="form-control"
                                    value={editUser.address}
                                    onChange={(e) => {
                                      setEditUser({
                                        ...editUser,
                                        address: e.target.value,
                                      });
                                    }}
                                    placeholder={lang["p.address"]}
                                  />
                                  {errorMessagesedit.address && (
                                    <span className="error-message">
                                      {errorMessagesedit.address}
                                    </span>
                                  )}
                                </div>
                                <div className="form-group col-lg-12">
                                  <label
                                    className="font-weight-bold text-small"
                                    for="projectdetail"
                                  >
                                    {lang["note"]}
                                  </label>

                                  <div
                                    className="col-lg-12"
                                    style={{
                                      border: "1px solid black",
                                      minHeight: "6em",
                                      cursor: "text",
                                    }}
                                  >
                                    {/* <Editor
                                          editorState={editorState}
                                          toolbarClassName="toolbarClassName"
                                          wrapperClassName="wrapperClassName"
                                          editorClassName="editorClassName"
                                          onEditorStateChange={onEditorStateChange}
                                          handleBeforeInput={handleBeforeInput}
                                          handleKeyCommand={handleKeyCommand}
                                          toolbar={{
                                            options: [
                                              "inline",
                                              "blockType",
                                              "fontSize",
                                              "fontFamily",
                                              "list",
                                              "textAlign",
                                              "colorPicker",
                                              "link",
                                              "emoji",
                                              "image",
                                              "remove",
                                              "history",
                                            ],
                                            inline: {
                                              options: [
                                                "bold",
                                                "italic",
                                                "underline",
                                              ],
                                            },
                                            list: {
                                              options: ["unordered", "ordered"],
                                            },
                                            textAlign: {
                                              options: [
                                                "left",
                                                "center",
                                                "right",
                                                "justify",
                                              ],
                                            },
                                            link: {
                                              options: ["link", "unlink"],
                                            },
                                            image: {
                                              uploadCallback: uploadImageCallBack,
                                              alt: {
                                                present: true,
                                                mandatory: false,
                                              },
                                              previewImage: true,
                                            },
                                            history: {
                                              options: ["undo", "redo"],
                                            },
                                            fontFamily: {
                                              options: [
                                                "Arial",
                                                "Georgia",
                                                "UTM Avo",
                                                "Tahoma",
                                                "Times New Roman",
                                                "Verdana",
                                              ],
                                            },
                                          }}
                                        /> */}
                                  </div>
                                  <div className="col-md-12">
                                    <textarea
                                      maxlength="500"
                                      rows="5"
                                      type="text"
                                      className="form-control"
                                      value={editUser.note}
                                      onChange={(e) => {
                                        setEditUser({
                                          ...editUser,
                                          note: e.target.value,
                                        });
                                      }}
                                      placeholder={lang["p.note"]}
                                    />
                                  </div>

                                  {/* <textarea
                                                                          disabled
                                                                          value={draftToHtml(convertToRaw(editorState.getCurrentContent()))}
                                                                      ></textarea> */}
                                  {/* <textarea maxlength="500" rows="5" type="text" className="form-control" value={draftToHtml(convertToRaw(editorState.getCurrentContent()))} onChange={
                                                                          (e) => { setEditUser({ ...editUser, note: draftToHtml(convertToRaw(editorState.getCurrentContent())) }) }
                                                                      } placeholder={lang["p.note"]} /> */}
                                </div>
                              </div>
                            </form>
                          </div>
                          <div className="modal-footer">
                            <button
                              type="button"
                              onClick={submitUpdate}
                              className="btn btn-success"
                            >
                              {lang["btn.update"]}
                            </button>
                            <button
                              type="button"
                              data-dismiss="modal"
                              className="btn btn-danger"
                            >
                              {lang["btn.close"]}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="full price_table padding_infor_info infor_user"
                    style={{ height: "79vh" }}
                  >
                    <>
                      {isChangePassword ? (
                        <ChangePassword profile={profile} />
                      ) : Object.values(profile).length > 0 ? (
                        <ChangeProfile
                          profile={profile}
                          fileInputRef={fileInputRef}
                          handleClick={handleClick}
                          handleFileUpload={handleFileUpload}
                          isAvatar={isAvatar}
                        />
                      ) : // <div className="full dis_flex center_text flex-column align-items-center">
                      //   {/* Profile Image */}
                      //   <div
                      //     className="profile_img m-0"
                      //     onClick={handleClick}
                      //   >
                      //     <img
                      //       width="80"
                      //       className="rounded-circle pointer"
                      //       src={proxy() + profile.avatar}
                      //       alt="Profile"
                      //       onError={(e) => {
                      //         const defaultAvatar =
                      //           proxy() + "/image/avatar/default-ava.png";
                      //         if (e.target.src !== defaultAvatar) {
                      //           e.target.src = defaultAvatar;
                      //         }
                      //       }}
                      //       title={lang["select file"]}
                      //     />
                      //     <input
                      //       type="file"
                      //       accept="image/*"
                      //       ref={fileInputRef}
                      //       style={{ display: "none" }}
                      //       onChange={handleFileUpload}
                      //     />
                      //   </div>

                      //   {/* Profile Form */}
                      //   <div className="profile_contant mt-4">
                      //     <div className="contact_inner">
                      //       {/* Username */}
                      //       <div className="mb-3 row">
                      //         <label className="col-sm-2 col-form-label">
                      //           Username
                      //         </label>
                      //         <div className="col-sm-7">
                      //           <input
                      //             type="text"
                      //             className="form-control"
                      //             defaultValue={profile.username}
                      //           />
                      //         </div>
                      //       </div>

                      //       {/* Fullname */}
                      //       <div className="mb-3 row">
                      //         <label className="col-sm-2 col-form-label">
                      //           Fullname
                      //         </label>
                      //         <div className="col-sm-7">
                      //           <input
                      //             type="text"
                      //             className="form-control"
                      //             defaultValue={profile.fullname}
                      //           />
                      //         </div>
                      //       </div>

                      //       {/* Email */}
                      //       <div className="mb-3 row">
                      //         <label className="col-sm-2 col-form-label">
                      //           Email
                      //         </label>
                      //         <div className="col-sm-7">
                      //           <input
                      //             type="text"
                      //             className="form-control"
                      //             defaultValue={profile.email}
                      //           />
                      //         </div>
                      //       </div>

                      //       {/* Phone */}
                      //       <div className="mb-3 row">
                      //         <label className="col-sm-2 col-form-label">
                      //           Phone
                      //         </label>
                      //         <div className="col-sm-7">
                      //           <input
                      //             type="number"
                      //             className="form-control"
                      //             defaultValue={profile.number}
                      //           />
                      //         </div>
                      //       </div>

                      //       {/* Address */}
                      //       <div className="mb-3 row">
                      //         <label className="col-sm-2 col-form-label">
                      //           Address
                      //         </label>
                      //         <div className="col-sm-7">
                      //           <input
                      //             type="text"
                      //             className="form-control"
                      //             defaultValue={profile.address}
                      //           />
                      //         </div>
                      //       </div>

                      //       {/* Note */}
                      //       <div className="mb-3 row">
                      //         <label className="col-sm-2 col-form-label">
                      //           Note
                      //         </label>
                      //         <div className="col-sm-7">
                      //           <textarea
                      //             className="form-control"
                      //             rows={5}
                      //             defaultValue={profile.note}
                      //           ></textarea>
                      //         </div>
                      //       </div>
                      //     </div>
                      //   </div>
                      // </div>
                      null}
                    </>
                  </div>
                </div>
              </div>
            </div>
          ) : // <div className="row column1">
          //     <div className="container justify-content-center">
          //         <div className="col-md-12 col-lg-12">
          //             <div className="full_profile white_shd">
          //                 <div className="info_people">

          //                     <div className="profile_contant">
          //                         <div className="contact_inner">
          //                             <h3>{user.role === "pd" ? "Normal" : "Administrator"}</h3>
          //                             <ul className="list-unstyled">
          //                                 <li className="mt-2 inline">{lang["fullname"]}:  {user.fullname}</li>
          //                                 <li className="mt-2 inline">{lang["username"]}:  {user.username}</li>
          //                                 <li className="mt-2"><i className="fa fa-envelope-o"></i> : {user.email || lang["no info"]}</li>
          //                                 <li className="mt-2"> <i className="fa fa-phone"></i> : {user.phone || lang["no info"]}</li>

          //                             </ul>
          //                         </div>

          //                     </div>
          //                 </div>
          //             </div>
          //         </div>
          //     </div>
          // </div>
          null}
        </div>
      </div>
    );
  }
}
